import { Stack, Typography, Divider } from '@mui/material'
import { DownloadFile } from 'components/DownloadFile'
import { useTranslation } from 'react-i18next'
import { ILot } from 'types/lots'

type Props = {
  lot: ILot
}

export const LotInformation = ({ lot }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Stack direction="row" spacing={1}>
        <Stack alignItems="flex-end" spacing={0.75}>
          <Typography variant="body1">{t('lot-number')}</Typography>
          <Typography variant="body1">{t('tenderPredmet')}</Typography>
          <Typography variant="body1">{t('delivery-address')}</Typography>
          <Typography variant="body1">{t('delivery-time')}</Typography>
          <Typography variant="body1">{t('delivery-terms')}</Typography>
          <Typography variant="body1">{t('payment-terms')}</Typography>
          <Typography variant="body1">{t('contract-type')}</Typography>
          <Typography variant="body1">{t('currency')}</Typography>
          <Typography variant="body1">{t('conditions')}</Typography>
        </Stack>
        <Divider orientation="vertical" flexItem sx={{ borderWidth: '2px' }} />
        <Stack spacing={0.75}>
          <Typography variant="body1">{lot.id}</Typography>
          <Typography variant="body1">-</Typography>
          <Typography variant="body1">{lot.deliveryAddress ?? '-'}</Typography>
          <Typography variant="body1">{lot.deliveryDurationDays ?? '-'}</Typography>
          <Typography variant="body1">{lot.deliveryTerms ?? '-'}</Typography>
          <Typography variant="body1">{lot.paymentTerms ?? '-'}</Typography>
          <Typography variant="body1">
            <DownloadFile fileId={lot.contractTemplateFileId} />
          </Typography>
          <Typography variant="body1">AZN</Typography>
          <Typography variant="body1">
            {lot.termsFileId ? <DownloadFile fileId={lot.termsFileId} /> : '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack>
        <Typography fontWeight="bold" variant="body1">
          {t('extra-info-short')}
        </Typography>
        <Typography variant="body1">{lot.extraInfo ?? '-'}</Typography>
      </Stack>
    </>
  )
}
